<div class="PGImport">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="d-flex justify-content-between align-items-center mb-3">
                    <h3 class="m-0">{{ 'pg-import.title' | locTranslate }}</h3>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-9 PGImport-Main">
                <div>
                    <ul class="nav nav-tabs mb-3">
                        @for (type of importTypeList; track type) {
                            @if (hasImportType(type)) {
                                <li class="nav-item">
                                    <button class="nav-link {{ importType == type ? 'active' : '' }}" [disabled]="importType == type" (click)="goToImportType(type)">
                                        @if (getImportTypeIcon(type); as icon ) {
                                            <i class="{{ icon }} me-2"></i>
                                        }
                                        <span>{{ 'pg-import.from-' + type | locTranslate }}</span>
                                    </button>
                                </li>
                            }
                        }
                    </ul>
                </div>
                @if (importType == 'entourance') {
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-6 form-group">
                                <label><b>{{ 'pg-import.api-url' | locTranslate }}</b></label>
                                <app-pg-select [options]="APIUrlOptions" [(ngModel)]="APIUrl" (ngModelChange)="onAPIUrlChange()" [required]="true"></app-pg-select>
                            </div>
                            <div class="col-6 form-group">
                                <label><b>{{ 'pg-import.select-resource' | locTranslate }}</b></label>
                                <app-pg-select [options]="resourceOptions" [(ngModel)]="resourceId" (ngModelChange)="onResourceIdChange()" [required]="true"></app-pg-select>
                            </div>
                        </div>
                        @if (APIUrl != null) {
                            <div class="row">
                                <div class="col-12">
                                    <app-pg-import-resource importType="entourance" [APIUrl]="APIUrl" [allowedRealms]="allowedRealms" [resourceId]="resourceId" [(selection)]="elementList" (selectionChange)="onElementListChange()"></app-pg-import-resource>
                                </div>
                            </div>
                        }
                    </div>
                }
                @if (importType == 'file') {
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-12 pb-3">
                                <a target="_blank" href="{{getImportTemplateUrl('xlsx')}}">{{ 'pg-import.download-xlsx-template' | locTranslate }}</a>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 form-group">
                                <label class="me-2"><b>{{ 'pg-import.file' | locTranslate }}</b></label>
                                <div>
                                    <app-pg-upload-button accept=".csv,.xlsx" (setFiles)="onSetFiles($event)"></app-pg-upload-button>
                                    @if (importFile != null) {
                                        <span class="ms-2">{{importFile.name}}</span>
                                    }
                                </div>
                            </div>
                        </div>
                        @if (isImportFileCSV()) {
                            <div class="row">
                                <div class="col-12 form-group">
                                    <label><b>{{ 'pg-import.select-resource' | locTranslate }}</b></label>
                                    <app-pg-select [options]="resourceOptions" [(ngModel)]="resourceId" (ngModelChange)="onResourceIdChange()" [required]="true"></app-pg-select>
                                </div>
                            </div>
                        }
                    </div>
                }
                @if (importType == 'wordpress') {
                    <div class="container-fluid">
                        <app-pg-import-resource importType="wordpress" [APIUrl]="APIUrl" [resourceId]="resourceId" [(selection)]="elementList" (selectionChange)="onElementListChange()"></app-pg-import-resource>
                    </div>
                }
                @if (importType == 'dhm') {
                    <div class="container-fluid">
                        <app-pg-import-tree importType="dhm" [(selection)]="resourceElementList" [importedKeys]="checkImportedKeys" (selectionChange)="onResourceElementListChange()"></app-pg-import-tree>
                    </div>
                }
                @if (importType == 'eppoi') {
                    <div class="container-fluid">
                        <app-pg-import-tree importType="eppoi" [(selection)]="resourceElementList" [importedKeys]="checkImportedKeys" (selectionChange)="onResourceElementListChange()"></app-pg-import-tree>
                    </div>
                }
            </div>
            <div class="col-3 border-start PGImport-Jobs">
                <div>
                    <div>
                        <app-pg-import-job [job]="editJob"></app-pg-import-job>
                    </div>
                    <div class="mt-2 d-flex justify-content-between align-items-center">
                        <div>
                            @if(shouldShowUpdateAlreadyImported()) {
                                @if(importType != 'file') {
                                    <div>
                                        @if(!isCheckIncomplete()) {
                                            <i class="fa-arrows-rotate fa-regular text-primary me-2"></i>
                                            <b>{{ 'pg-import.check-imported-summary' | locTranslate:'imported':getCheckImportedCount() }}</b>
                                        }
                                    </div>
                                }
                                <div>
                                    <input id="PGImport-UpdateAlreadyImported" type="checkbox" class="me-2" [(ngModel)]="updateAlreadyImported" (ngModelChange)="(!$event ? updateSecondariesToo = false : null)">
                                    <label for="PGImport-UpdateAlreadyImported">{{ 'pg-import.update-already-imported' | locTranslate }}</label>
                                </div>
                                @if(hasUpdateSecondariesToo()) {
                                    <div>
                                        <input id="PGImport-UpdateSecondariesToo" type="checkbox" class="me-2" [(ngModel)]="updateSecondariesToo" (ngModelChange)="($event ? updateAlreadyImported = true : null)">
                                        <label for="PGImport-UpdateSecondariesToo">{{ 'pg-import.update-secondaries-too' | locTranslate }}</label>
                                    </div>
                                }
                            }
                        </div>
                        <button class="btn btn-primary ms-3 my-2" [disabled]="isImportDisabled()" (click)="doImport()">{{ 'pg-import.import' | locTranslate }}</button>
                    </div>
                    <hr/>
                </div>
                <div #scrollContainer>
                    @if (importerJobs == null) {
                        <div>
                            <h5 class="text-muted">{{ 'pg-import.import-history-not-available' | locTranslate }}</h5>
                            <div class="text-muted">{{ 'pg-import.websocket-not-connected' | locTranslate }}</div>
                        </div>
                    }
                    @if (importerJobs != null) {
                        @if(importerJobs.length == 0 && isImporterJobsFinishedAtEnd) {
                            <div>
                                <h5 class="text-muted">{{ 'pg-import.no-imports' | locTranslate }}</h5>
                            </div>
                        }

                        @for (job of importerJobs; track job; let i = $index) {
                            <div>
                                @if (i != 0) {
                                    <hr/>
                                }
                                <app-pg-import-job [job]="job" [APIUrlOptions]="APIUrlOptions" (cancel)="jobCancel(job)"> <!-- TOFIX: questo viene rigenerato ogni volta -->
                                    @if(!isJobInProgress(job)) {
                                        <div>
                                            @if (hasJobUpdate(job)) {
                                                <button class="btn btn-primary btn-sm me-1 my-1" (click)="jobUpdate(job)">{{ 'pg-import.request-update' | locTranslate }}</button>
                                            }
                                            @if (hasJobUpdate(job, true)) {
                                                <button class="btn btn-primary btn-sm me-1 my-1" (click)="jobUpdate(job, true)">{{ 'pg-import.request-update-secondaries' | locTranslate }}</button>
                                            }
                                            @if (hasJobInsert(job)) {
                                                <button class="btn btn-primary btn-sm me-1 my-1" (click)="jobInsert(job)">{{ 'pg-import.request-insert' | locTranslate }}</button>
                                            }
                                        </div>
                                    }
                                </app-pg-import-job>
                            </div>
                        }

                        @if(isImporterJobsFinishedLoading) {
                            <div>
                                <app-pg-loading></app-pg-loading>
                            </div>
                        }
                        <app-pg-view-more [hidden]="isImporterJobsFinishedLoading || isImporterJobsFinishedAtEnd" (viewMore)="loadMoreFinishedJobs()"></app-pg-view-more>
                    }
                </div>
            </div>
        </div>
    </div>
</div>
